// Tab Switcher

class TabSwitcher extends HTMLElement {
    constructor() {
      super();
    }
  
    connectedCallback() {
      this.querySelectorAll('input[type="radio"]').forEach((radio) => {
        radio.addEventListener('change', () => this.handleTabChange(radio));
      });
  
      document.addEventListener('shopify:section:select', () => {
        const radio = this.querySelector('input[type="radio"]:checked');
        this.handleTabChange(radio);
      });
  
      const checkedRadio = this.querySelector('input[type="radio"]:checked');
      if (checkedRadio) {
        this.handleTabChange(checkedRadio);  
      } else {
        const firstRadio = this.querySelector('input[type="radio"]');
        if (firstRadio) {
          firstRadio.checked = true;  
          this.handleTabChange(firstRadio);  
        }
      }
  
      window.addEventListener('resize', () => {
        const radio = this.querySelector('input[type="radio"]:checked');
        if (radio) {
          this.updateGliderPosition(radio);
        }
      });
    }
  
  handleTabChange(radio) {
      const parts = radio.id.split('-');
      const sectionId = parts[1];
  
      if (parts.length < 3) {
          return; 
      }
  
      const collectionNumber = parseInt(parts[parts.length - 1], 10) - 1;
  
      this.querySelectorAll('.tab-content > div').forEach((content, index) => {
          if (index === collectionNumber) {
              content.style.display = 'block';
              content.setAttribute('data-aos', 'fade-up');
          } else {
              content.style.display = 'none';
              content.removeAttribute('data-aos');
              content.classList.remove('aos-animate');
          }
      });
  
      this.updateGliderPosition(radio);
  
      if (typeof AOS !== 'undefined') {
      AOS.init();
  }
  
  }
  
    updateGliderPosition(radio) {
      const glider = this.querySelector('.glider');
      const selectedLabel = radio.nextElementSibling; 
  
      const tabWidth = selectedLabel.offsetWidth;
      const tabLeft = selectedLabel.offsetLeft;
  
      glider.style.width = `${tabWidth}px`;
      glider.style.transform = `translateX(${tabLeft}px)`;
    }
  }
  
  customElements.define('tab-switcher', TabSwitcher);